import FiveTwoNineSavings from 'tio-employee/components/five-two-nine/savings';

<template><FiveTwoNineSavings /></template>
